module.exports = __webpack_public_path__ + "img/avatar_real_1.4c55092f.jpg";